var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoPayout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(75,174,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.656 43 h -3.313 c -3.635 0 -6.592 -2.809 -6.592 -6.262 v -3.669 c 0 -3.453 2.957 -6.262 6.592 -6.262 h 3.745 c 3.396 0 6.159 2.623 6.159 5.846 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 c 0 -5.429 -4.558 -9.846 -10.159 -9.846 H 47 V 18 c 0 -1.104 -0.896 -2 -2 -2 s -2 0.896 -2 2 v 4.824 c -5.681 0.178 -10.248 4.699 -10.248 10.245 v 3.669 C 32.752 42.396 37.503 47 43.344 47 h 3.313 c 3.635 0 6.592 2.81 6.592 6.263 v 3.669 c 0 3.453 -2.957 6.262 -6.592 6.262 h -3.746 c -3.396 0 -6.159 -2.622 -6.159 -5.846 c 0 -1.104 -0.896 -2 -2 -2 s -2 0.896 -2 2 c 0 5.429 4.557 9.846 10.159 9.846 H 43 V 72 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 v -4.824 c 5.681 -0.178 10.248 -4.699 10.248 -10.245 v -3.669 C 57.248 47.604 52.497 43 46.656 43 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPayout);
export default __webpack_public_path__ + "static/media/AutoPayout.e5708d6c08c1c9eca268ed7fdc280762.svg";
export { ForwardRef as ReactComponent };